module.exports = __webpack_public_path__ + "images/iphone-gbi-mockup_2d8867a.png";